var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"dev-status-row"},[_c('el-col',{attrs:{"span":24}},[_c('div',{ref:"myRef5",staticClass:"chart-box",attrs:{"id":"pieChart5"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }